import { FilterFieldsType } from "../types";

const DATE_MASK = /^\d{2}-\d{2}-\d{4}$/;

/* DD-MM-YYYY -> YYYY-MM-DD */
export const convertDateFormat = (dateStr: string): string => {
  const [day, month, year] = dateStr.split("-");
  if (!day || !month || !year) {
    return "";
  }

  return `${year}-${month}-${day}`;
};

/**
 * Выбранный диапазон дат хранится в сторе как ["DD-MM-YYYY", "DD-MM-YYYY"],
 * а бэк ждёт значения из справочника фильтров. Без конвертации запрос
 * не находит ни одного заказа, и списки опций приходят пустыми.
 *
 * `allCreatedDates` — полный справочник дат: если брать даты из последнего
 * ответа `/filters/order`, они уже сужены прошлым набором фильтров, и после
 * сброса одного из фильтров выборка остаётся привязанной к нему.
 */
export const formatCreatedFilterField = (
  fields: FilterFieldsType | [],
  allCreatedDates: string[],
): FilterFieldsType | [] => {
  const created = (fields as FilterFieldsType).created;

  if (
    !created ||
    created.length !== 2 ||
    !created.every((date) => DATE_MASK.test(date))
  ) {
    return fields;
  }

  const startDate = convertDateFormat(created[0]);
  const endDate = convertDateFormat(created[1]);

  const choosenCreatedFilterItems = allCreatedDates.filter((item) => {
    const filterDate = item.split(" ")[0];
    return startDate <= filterDate && filterDate <= endDate;
  });

  return {
    ...(fields as FilterFieldsType),
    created: choosenCreatedFilterItems.length
      ? choosenCreatedFilterItems
      : [
          `${startDate} 00:00:00.0000000 +00:00`,
          `${endDate} 23:59:59.9999999 +00:00`,
        ],
  };
};
